<template>
  <ul style="column-gap: 10px" class="d-flex">
    <li v-for="(button, idx) in buttons" :key="idx">
      <base-button v-bind="button" class="font-size-11 font-weight-regular" @click="onClick(button)" />
    </li>
  </ul>
</template>

<script>
import { get } from 'vuex-pathify';
import BaseButton from '@/components/shared/buttons/BaseButton';

export default {
  name: 'FilterButtons',
  components: { BaseButton },
  computed: {
    isFilterActive: get('map/isFilterActive'),
    buttons() {
      return [
        ...(this.isFilterActive
          ? [
              {
                name: 'clearFilter',
                text: 'buttons.clearFilter',
                color: 'secondary',
              },
            ]
          : []),
      ];
    },
  },
  methods: {
    onClick(button) {
      this.$emit(button.name, button);
    },
  },
};
</script>
